var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card__info"},_vm._l((_vm.tags),function(tag){return _c('div',{staticClass:"info__line"},[_c('i',{staticClass:"demo-icon icon-tick"}),_c('span',{},[_vm._v(_vm._s(tag))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }